module.exports = __webpack_public_path__ + "media/images/common/h3_kuchikomi-d63e6df907268341c9ac0bc920fef4ef.gif";